module.exports = __webpack_public_path__ + "static/media/EHS-Supervision-policy-protected.1868b907.pdf";